import type { Messages } from './en';

/**
 * Charla rotativa. Cada personaje tiene saludos según la hora del día y varios temas;
 * cada tema ofrece tres respuestas (cariñosa, curiosa, juguetona), cada una con su réplica.
 */
export const esTalks: Messages['talks'] = {
  chat: '💬 Charlar',
  emma: {
    greet: {
      morning: ['¡Buenos días! ¿Has dormido bien?', '¡Buenos días! Hoy he traído leche de fresa.'],
      afternoon: ['¡Ey! ¿Qué tal la clase?', '¡Hola! ¿A que hace una tarde preciosa?'],
      evening: ['¡Ah, hola! Me voy a casa enseguida.', '¡Hoy la puesta de sol es preciosa!'],
    },
    topics: [
      {
        say: 'Estoy aprendiendo una canción nueva en inglés. ¿Te gusta la música?',
        choices: [
          { t: '¡Me encanta! ¿Me la cantas?', reply: 'Vale, solo el estribillo… ¡la la la! ¡Jaja, no te rías!' },
          { t: '¿De qué va la canción?', reply: 'De ser valiente aunque te sientas pequeñito. Me gusta mucho.' },
          { t: '¡Solo si también bailas!', reply: '¡Jaja! Vale, ¡pero tienes que bailar conmigo!' },
        ],
      },
      {
        say: 'Si pudieras viajar a cualquier sitio, ¿adónde irías?',
        choices: [
          { t: '¡A algún sitio contigo y con nuestros amigos!', reply: 'Ooh, es la mejor respuesta. ¡Pues excursión de clase!' },
          { t: '¿Y tú adónde irías?', reply: 'A Kioto, a ver los templos. ¡O a los Alpes, por la nieve!' },
          { t: 'A la luna. Está clarísimo.', reply: '¡Jaja! Lleva merienda. Mucha merienda.' },
        ],
      },
      {
        say: 'He sacado peor nota de la que esperaba en el examen de mates…',
        choices: [
          { t: 'Te has esforzado mucho. Eso es lo que más importa.', reply: 'Gracias… Tienes razón. Le preguntaré a la profe lo que he fallado.' },
          { t: '¿Qué parte te costó? Podemos estudiar juntos.', reply: '¡Las fracciones! Puf. Vale, ¿quedamos para estudiar en la biblioteca?' },
          { t: 'Las mates son números haciéndose los dramáticos.', reply: '¡Jajaja! La verdad es que eso me ha animado.' },
        ],
      },
      {
        say: 'Esta mañana mi gata me ha tirado los deberes de la mesa.',
        choices: [
          { t: '¡Oh, no! ¿Están bien?', reply: 'Un poco arrugados, pero bien. Eso sí, mi gata parecía muy orgullosa.' },
          { t: '¿Cómo se llama tu gata?', reply: '¡Pudin! Es naranja y muy redondita.' },
          { t: 'Tu gata quería ayudarte con los deberes.', reply: 'Jaja, pues es malísima en inglés.' },
        ],
      },
    ],
  },
  rain: {
    greet: {
      morning: ['¡Buenos días! Ya voy por el capítulo cinco.', '¡Hola! ¿Quieres que te preste un libro?'],
      afternoon: ['¡Chis, voz de biblioteca! ¡Hola!', '¡Anda, eres tú! Llegas justo a tiempo.'],
      evening: ['Me he vuelto a quedar hasta tarde leyendo.', 'Una página más… vale, diez páginas más.'],
    },
    topics: [
      {
        say: 'Estoy leyendo una novela de misterio. ¡Creo que ya sé quién ha sido!',
        choices: [
          { t: '¡No me lo digas! Yo también quiero leerla.', reply: 'Mis labios están sellados. Te la presto cuando la termine.' },
          { t: '¿Qué pistas has encontrado?', reply: 'Un zapato lleno de barro y un paraguas desaparecido. Muy sospechoso.' },
          { t: 'Fue el mayordomo. Siempre es el mayordomo.', reply: '¡Jaja! ¡Si en esta historia ni siquiera hay mayordomo!' },
        ],
      },
      {
        say: 'A veces me pongo nerviosa cuando hablo en clase.',
        choices: [
          { t: 'Le pasa a mucha gente. No estás sola.', reply: '¿De verdad? Eso me ayuda. A lo mejor mañana levanto la mano una vez.' },
          { t: '¿Qué es lo que te da miedo?', reply: 'Que todo el mundo me mire. Pero practicar contigo me ayuda.' },
          { t: 'Imagina que todos son patatas.', reply: 'Patatas… vale, es una tontería, ¡pero igual funciona!' },
        ],
      },
      {
        say: '¿Qué prefieres: cómics o novelas?',
        choices: [
          { t: '¡Las dos cosas! Una historia es una historia.', reply: '¡Exacto! Las buenas historias son buenas historias.' },
          { t: '¿Me recomiendas alguno?', reply: 'Prueba «La guardiana del farol». Va de una chica que cuida un faro.' },
          { t: 'Libros de cocina. Me gustan las fotos.', reply: '¡Jaja! Ahora tengo hambre.' },
        ],
      },
    ],
  },
  teacher: {
    greet: {
      morning: ['Buenos días. ¿Preparado/a para hoy?', '¡Buenos días! Acuérdate de beber agua.'],
      afternoon: ['¡Hola! ¿Qué tal van las clases?', 'Ah, hola. ¿Día ajetreado?'],
      evening: ['¿Todavía sigues aquí? No te olvides de ir a casa a descansar.', 'Buen trabajo hoy.'],
    },
    topics: [
      {
        say: 'Ayudar a los demás es maravilloso, pero también tienes que cuidarte tú.',
        choices: [
          { t: 'Lo haré. Gracias, profesora Lin.', reply: 'Muy bien. Descansa, come bien y pide ayuda cuando la necesites.' },
          { t: '¿Y usted cómo se cuida?', reply: 'Una taza de té, un paseo y acostarme pronto. Las cosas sencillas funcionan.' },
          { t: 'Me comeré una galleta de más por mi salud.', reply: 'Jaja. Una galleta. Y una pieza de fruta.' },
        ],
      },
      {
        say: 'La clase 8-3 está organizando un mercadillo solidario. ¿Alguna idea?',
        choices: [
          { t: '¡Galletas caseras! Yo sé hornear.', reply: 'Qué buena idea. La gente siempre compra dulces caseros.' },
          { t: '¿Para qué será el dinero?', reply: 'Para comprar libros para el hospital infantil. Buena causa, ¿verdad?' },
          { t: '¿Una piscina para remojar a los profes?', reply: 'Ni hablar. Aunque buen intento.' },
        ],
      },
      {
        say: '¿Has terminado la lectura de esta semana?',
        choices: [
          { t: '¡Sí! Me ha gustado el final.', reply: 'A mí también. Lo comentaremos en clase.' },
          { t: 'Todavía no. ¿Es larga?', reply: 'Veinte páginas. Lee un poquito cada día: ese es el truco.' },
          { t: 'Se la comió mi gato.', reply: 'Mmm, el famoso gato que se come los deberes. Me suena.' },
        ],
      },
    ],
  },
  chunbo: {
    greet: {
      morning: ['¡Buenos días, chaval!', 'Madrugando, ¿eh? Muy bien hecho.'],
      afternoon: ['¡Buenas tardes! ¿Portándote bien?', 'Hoy hace calor, ¿eh?'],
      evening: ['¿Te vas a casa? Cuidado con el tráfico.', 'Otro día terminado. Buen trabajo.'],
    },
    topics: [
      {
        say: 'Cuando yo tenía tu edad, caminaba una hora cada día para ir al colegio.',
        choices: [
          { t: '¡Hala, qué pasada!', reply: '¡Y me encantaba! Cada mañana veía arrozales y búfalos.' },
          { t: '¿Cómo era el colegio entonces?', reply: 'Pequeño. Una clase, un maestro y mucho jaleo.' },
          { t: '¿Cuesta arriba a la ida y a la vuelta?', reply: '¡Jaja! Qué listo eres. Solo a la ida. ¡La vuelta era cuesta abajo!' },
        ],
      },
      {
        say: 'Tengo un pequeño huerto detrás de mi caseta.',
        choices: [
          { t: '¿Puedo ayudarle a regarlo algún día?', reply: '¡Pues claro! A los tomates les gusta la compañía.' },
          { t: '¿Qué cultiva?', reply: 'Tomates, albahaca y una calabaza muy cabezota.' },
          { t: '¿Las plantas también vigilan la puerta?', reply: '¡Jaja! La calabaza es mi ayudante.' },
        ],
      },
      {
        say: 'Recuerda: si un desconocido te pide que vayas a algún sitio, di que no y ven a buscarme.',
        choices: [
          { t: 'Lo haré, tío Chun.', reply: 'Muy bien. La seguridad, siempre lo primero.' },
          { t: '¿Y si dice que conoce a mi madre?', reply: 'Di que no igualmente. Tu familia nunca enviaría a un desconocido sin avisarte.' },
          { t: 'Haré una pose de kárate y saldré corriendo.', reply: '¡Con la parte de salir corriendo basta!' },
        ],
      },
    ],
  },
  librarian: {
    greet: {
      morning: ['Buenos días, cielo.', '¡Vaya, alguien que lee tempranito!'],
      afternoon: ['Hola. ¿Buscas algo especial?', 'Bienvenido/a otra vez.'],
      evening: ['Cerramos pronto, pero tómate tu tiempo.', '¡Última oportunidad para llevarte un libro hoy!'],
    },
    topics: [
      {
        say: 'Cada libro es una puerta a otro mundo.',
        choices: [
          { t: '¿Qué puerta debería abrir ahora?', reply: 'Prueba un libro sobre el océano. Nunca volverás a ver los peces igual.' },
          { t: '¿Cuál fue su primer libro favorito?', reply: 'Uno sobre un ratoncito muy valiente. Lo leí treinta veces.' },
          { t: '¿Tiene algún libro sobre puertas?', reply: '¡Ja! Pues… sí. Arquitectura, estantería doce.' },
        ],
      },
      {
        say: 'Trata con cuidado los libros antiguos, por favor. ¡Son más viejos que yo!',
        choices: [
          { t: 'Tendré cuidado, se lo prometo.', reply: 'Gracias. Los libros recuerdan quién los trata con cariño.' },
          { t: '¿Cuántos años tiene el más antiguo?', reply: '¡Más de ochenta! Es un diccionario con las páginas finísimas.' },
          { t: '¿Más viejos que usted? ¡Imposible!', reply: 'Ay, qué zalamero/a. ¡Venga, ve a leer algo!' },
        ],
      },
    ],
  },
  coach: {
    greet: {
      morning: ['¡Buenos días! ¡Primero, a estirar!', '¡Arriba, campeón/a!'],
      afternoon: ['¡Ey! ¿Te echas una vuelta corriendo?', '¡Mantén esa energía!'],
      evening: ['Estira un poco y luego a casa.', '¡Buen esfuerzo hoy!'],
    },
    topics: [
      {
        say: 'El deporte no va de ganar. Va de mejorar un poquito cada día.',
        choices: [
          { t: 'Daré lo mejor de mí cada día.', reply: '¡Ese es el espíritu! Pasos pequeños, grandes resultados.' },
          { t: '¿Cómo puedo ser más rápido/a?', reply: 'Duerme bien, come bien y practica las salidas. ¡Sal disparado/a!' },
          { t: '¿Puedo mejorar echando siestas?', reply: '¡Ja! El descanso es parte del entrenamiento. Pero solo después de entrenar.' },
        ],
      },
      {
        say: 'Bebe agua antes de tener sed. Tu cuerpo te lo agradecerá.',
        choices: [
          { t: '¡Entendido, entrenador!', reply: 'Bien. Hidratarse es un superpoder.' },
          { t: '¿Cuánta tengo que beber?', reply: 'Un vaso más o menos cada hora cuando haces ejercicio.' },
          { t: '¿El té de burbujas cuenta?', reply: 'Buen intento. ¡Primero, agua!' },
        ],
      },
    ],
  },
  clerk: {
    greet: {
      morning: ['¡Buenos días! Hoy hay pan recién hecho.', '¡Hola! ¿Compras tempranito?'],
      afternoon: ['¡Bienvenido/a! ¿Te ayudo con algo?', '¡Hola otra vez!'],
      evening: ['¡Buenas noches! Las bolas de arroz están a mitad de precio.', '¿Día largo? Llévate algo para picar.'],
    },
    topics: [
      {
        say: '¿Sabías que la tienda abre hasta las once?',
        choices: [
          { t: '¡Qué turno tan largo! Gracias por trabajar tanto.', reply: 'Ay, gracias. Con clientes como tú es fácil.' },
          { t: '¿Qué es lo que más se vende?', reply: '¡Los huevos al té! La gente compra docenas cada día.' },
          { t: '¿Duermes detrás del mostrador?', reply: '¡Jaja, solo en sueños!' },
        ],
      },
      {
        say: 'Estoy ahorrando para abrir mi propia cafetería algún día.',
        choices: [
          { t: '¡Lo conseguirás! Seré tu primer cliente.', reply: '¡Trato hecho! La primera taza de chocolate corre de mi cuenta.' },
          { t: '¿Cómo la llamarías?', reply: '«Café Farolillo». Acogedora y llena de plantas.' },
          { t: '¿Habrá galletas gratis?', reply: '¿Para mi primer cliente? ¡Por supuesto!' },
        ],
      },
    ],
  },
  grandma: {
    greet: {
      morning: ['Buenos días, pequeño/a.', 'Qué mañana tan fresquita, ¿verdad?'],
      afternoon: ['Ven, siéntate un ratito conmigo.', 'Hoy las palomas tienen hambre.'],
      evening: ['Pronto habrá que volver a casa.', 'Mira qué rosa está el cielo.'],
    },
    topics: [
      {
        say: 'Cuando yo era joven, este parque eran todo arrozales.',
        choices: [
          { t: 'Debía de ser precioso.', reply: 'Lo era. Verde hasta donde alcanzaba la vista, y ranas cantando por la noche.' },
          { t: '¿Y qué hacían para divertirse?', reply: 'Cazábamos luciérnagas en tarros y luego las soltábamos.' },
          { t: '¿Las palomas también vivían aquí?', reply: '¡Ja! ¡Sus tatarabuelas, a lo mejor!' },
        ],
      },
      {
        say: '¿Llamas a menudo a tus abuelos?',
        choices: [
          { t: 'Debería llamarlos más. ¡Lo haré!', reply: 'Se pondrán contentísimos. Una llamada cortita significa mucho.' },
          { t: '¿Qué les gusta oír a los abuelos?', reply: 'Qué has comido, qué has aprendido y que eres feliz.' },
          { t: '¡Les mando stickers!', reply: 'Los stickers están bien. Una voz es todavía mejor.' },
        ],
      },
    ],
  },
  bo: {
    greet: {
      morning: ['¡Hola! ¿Jugamos?', '¡Mira! ¡He encontrado una piedra brillante!'],
      afternoon: ['¡Pilla pilla! ¡Te la quedas! …Es broma.', '¡Soy un dinosaurio! ¡GRRR!'],
      evening: ['Mamá dice que pronto tengo que irme a casa…', '¡No tengo sueño! *bosteza*'],
    },
    topics: [
      {
        say: '¡De mayor quiero ser astronauta!',
        choices: [
          { t: '¡Serás un astronauta genial!', reply: '¡Sí! ¡Te saludaré desde la luna!' },
          { t: '¿Qué harás en el espacio?', reply: '¡Flotar! ¡Y comer helado espacial!' },
          { t: '¿Me llevas contigo?', reply: '¡Solo si traes merienda!' },
        ],
      },
      {
        say: '¿Sabes algún chiste?',
        choices: [
          { t: '¿Qué le dice una galleta a otra? ¡Qué galleta más mona, me derrito!', reply: '¡Jajaja! ¡No lo pillo, pero es gracioso!' },
          { t: '¿Y TÚ sabes alguno?', reply: '¿Qué le dice una vaca a otra? …¡Muuucho gusto! ¡Jajaja!' },
          { t: 'Toc, toc.', reply: '¿Quién es? …¡Espera, que quiero hacerlo yo!' },
        ],
      },
    ],
  },
  mom: {
    greet: {
      morning: ['Buenos días, cariño. El desayuno está listo.', '¡Buenos días! ¿Lo llevas todo?'],
      afternoon: ['Hola, cielo. ¿Qué tal el día?', '¡Ya estás en casa! Lávate las manos.'],
      evening: ['La cena estará lista enseguida.', 'Esta noche no te acuestes muy tarde.'],
    },
    topics: [
      {
        say: '¿Ha pasado hoy algo difícil de lo que quieras hablar?',
        choices: [
          { t: 'Un amigo estaba triste. Intenté ayudarle.', reply: 'Qué bonito por tu parte. ¿Sabes? Solo escuchar ya ayuda muchísimo.' },
          { t: '¿Y tú qué haces en los días difíciles, mamá?', reply: 'Me preparo un té, respiro hondo y me acuerdo de que mañana es un día nuevo.' },
          { t: 'Lo más difícil ha sido esperar la cena.', reply: '¡Jaja! Vale, vale, ya casi está.' },
        ],
      },
      {
        say: '¿Qué cocinamos este fin de semana?',
        choices: [
          { t: '¡Hagamos empanadillas juntos!', reply: '¡Sí! Tú las cierras y yo preparo el relleno.' },
          { t: '¿Me enseñas tu receta de sopa?', reply: 'Claro. Me la enseñó la abuela, y ahora te la enseño yo a ti.' },
          { t: '¿Pastel para cenar?', reply: 'Pastel de postre. ¡Verdura para cenar!' },
        ],
      },
      {
        say: 'Estoy orgullosa de lo responsable que te estás volviendo.',
        choices: [
          { t: 'Gracias, mamá. Lo he aprendido de ti.', reply: 'Ay, que me vas a hacer llorar. ¡Ven aquí!' },
          { t: '¿Qué te ha hecho sentir orgullosa hoy?', reply: 'Has ayudado sin que nadie te lo pidiera. Eso significa mucho.' },
          { t: '¿Lo bastante orgullosa para darme más paga?', reply: '¡Jaja, buen intento! Orgullosa, sí. Rica, no.' },
        ],
      },
    ],
  },
  sister: {
    greet: {
      morning: ['¡Despierta! ¡Juega conmigo!', '¡He dibujado un gato! ¡Mira!'],
      afternoon: ['¡Ya estás en casa! ¡Bien!', '¿Hacemos un puzle?'],
      evening: ['¿Me lees un cuento?', 'No tengo sueño… *bosteza*'],
    },
    topics: [
      {
        say: '¿La luna está siguiendo nuestro coche?',
        choices: [
          { t: '¡Eso parece! Quiere saludarnos.', reply: '¡Hola, luna! ¡Jiji!' },
          { t: 'Está muy, muy lejos, por eso parece que nos sigue.', reply: 'Ooh… ¿Entonces sigue a todo el mundo a la vez?' },
          { t: 'Sí. Es una luna muy cotilla.', reply: '¡Luna cotilla! ¡Jajaja!' },
        ],
      },
      {
        say: 'He tenido una pesadilla con un monstruo.',
        choices: [
          { t: 'Estoy aquí. Estás a salvo.', reply: 'Vale… ¿Puedes dejar la puerta un poquito abierta?' },
          { t: '¿Cómo era el monstruo?', reply: 'Grande y peludito… la verdad es que era un poco mono.' },
          { t: '¡Lo derrotaré con una almohada!', reply: '¡Guerra de almohadas! ¡Guerra de almohadas!' },
        ],
      },
    ],
  },
  dad: {
    greet: {
      morning: ['Buenos días, campeón/a.', '¡Buenos días! Primero, el café.'],
      afternoon: ['¡Hola, hola!', '¿Qué tal está mi peque favorito/a?'],
      evening: ['Uf, qué día más largo. Ven, siéntate conmigo.', '¡Esta noche cenamos todos juntos!'],
    },
    topics: [
      {
        say: 'Perdona que a veces trabaje hasta tan tarde.',
        choices: [
          { t: 'No pasa nada. Me gusta cuando cenamos juntos.', reply: 'A mí también. Intentaré volver pronto más a menudo.' },
          { t: '¿Qué haces todo el día en el trabajo?', reply: 'Muchas reuniones y hojas de cálculo. ¡No tan emocionante como el insti!' },
          { t: '¡Me debes una noche de juegos!', reply: '¡Trato hecho! Sábado, juegos de mesa y nada de móviles.' },
        ],
      },
      {
        say: '¿Quieres oír un chiste de papá?',
        choices: [
          { t: 'Venga, papá.', reply: '¿Qué le dice un huevo a otro? ¡Que me parto de risa contigo!' },
          { t: 'Solo si tiene gracia de verdad.', reply: '¿Cómo se llama un dinosaurio dormido? ¡Un dino-ronquido!' },
          { t: '¡Por favor, no!', reply: '¡Demasiado tarde! ¿Qué hace una abeja en el gimnasio? ¡Zum-ba!' },
        ],
      },
    ],
  },
  xiaoyu: {
    greet: {
      morning: ['…Hola.', 'Ah. Buenos días.'],
      afternoon: ['Ey.', 'Hola… gracias por lo de antes.'],
      evening: ['Debería irme ya a casa.', 'Ha sido un día normalito.'],
    },
    topics: [
      {
        say: 'Me gusta dibujar. Me ayuda cuando tengo mucho ruido en la cabeza.',
        choices: [
          { t: 'Es una forma genial de sentirse mejor.', reply: 'Ya. A lo mejor algún día te enseño mis dibujos.' },
          { t: '¿Qué te gusta dibujar?', reply: 'Robots. Y a veces a mi perro.' },
          { t: '¿Me dibujas como un superhéroe?', reply: '…Vale. Jaja. Con capa.' },
        ],
      },
      {
        say: '¿Alguna vez te sientes cansado/a de todo?',
        choices: [
          { t: 'A veces. Hablar con alguien ayuda.', reply: 'Ya… Hablar contigo me ayuda un poco.' },
          { t: '¿Qué es lo que te cansa?', reply: 'En casa hay mucho ruido. Pero el aula de orientación es tranquila.' },
          { t: 'Vamos a tomar un chocolate caliente.', reply: 'La verdad es que un chocolate suena bien.' },
        ],
      },
    ],
  },
};
